import * as React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const SvgMute = (props) => (
  <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={50} height={50} rx={8} fill="none" />
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}>
        <path
          stroke="var(--ax-gold)"
          d="m35.417 6.25-14.25 10.417H12.5a2.083 2.083 0 0 0-2.083 2.083v12.5a2.083 2.083 0 0 0 2.083 2.083h8.667l14.25 10.417z"
        />
        <AnimatePresence mode="wait">
          {props.muted && (
            <motion.path
              initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            exit={{ pathLength: 0 }}
            transition={{ duration: 0.5 }}
            stroke="var(--ax-gold)"
            d="M43.75 38.813 6.25 11.186"
            />
          )}
        </AnimatePresence>
      </g>
    </svg>
  </svg>
);
export default SvgMute;
